import React from 'react';
import styled from 'styled-components';
import { LuMessageCircle, LuX } from 'react-icons/lu';

// Botão flutuante do Ale. Sempre visível, canto inferior direito.
// Traz RÓTULO textual além do ícone (público idoso reconhece melhor).
const Fab = styled.button`
  position: fixed;
  right: 20px;
  bottom: 20px;
  /* Atrás da barra de preço (z-index 100), para o card expandido cobrir o balão */
  z-index: 90;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 56px;
  min-width: 56px;
  padding: 0 22px;
  border: none;
  border-radius: 9999px;
  background: ${(p) => p.theme.colors.primary};
  color: ${(p) => p.theme.colors.white};
  font-family: ${(p) => p.theme.fonts.primary};
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: ${(p) => p.theme.shadows.xl};
  transition: background-color 0.2s ease, transform 0.2s ease, bottom 0.2s ease;

  /* Sobe quando a barra de valor mensal está na tela (passo 2+). */
  body.has-price-summary-bar & {
    bottom: 110px;
  }

  &:hover {
    background: ${(p) => p.theme.colors.hoverPrimary};
  }
  &:focus-visible {
    outline: 3px solid ${(p) => p.theme.colors.info};
    outline-offset: 2px;
  }

  /* No celular, mostra só o ícone para não ocupar a tela. */
  @media (max-width: 768px) {
    padding: 0;
    width: 56px;
    gap: 0;

    body.has-price-summary-bar & {
      bottom: 88px;
    }

    svg {
      display: block;
      flex-shrink: 0;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

const LauncherText = styled.span`
  @media (max-width: 768px) {
    display: none;
  }
`;

const AleLauncher = ({ open, onClick, label }) => {
  return (
    <Fab
      type="button"
      onClick={onClick}
      aria-label={open ? 'Fechar assistente Ale' : label}
      aria-expanded={open}
    >
      {open ? <LuX size={24} aria-hidden="true" /> : <LuMessageCircle size={24} aria-hidden="true" />}
      <LauncherText>{label}</LauncherText>
    </Fab>
  );
};

export default AleLauncher;
